export default "<div class=\"preorder-type-chip\" *ngIf=\"preorderType !== pt.INSIDE\">\n\t{{ 'preorder_type.' + preorderType | translate }}\n</div>\n\n";